import Item from "./partials/Item/Item";
import React from "react";

const TableRow = ({ data, handleRefreshData, page, onUpdate }) => {
  return data.map((item, index) => {
    return (
      <Item
        item={item}
        index={index}
        key={index}
        handleRefreshData={handleRefreshData}
        page={page}
        onUpdate={onUpdate}
      />
    );
  });
};

export default TableRow;
